import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  updateAvatarFrame,
  crateAvatarFrame,
} from "../../store/AvatarFrame/action";

import SVGA from "svgaplayerweb";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Switch,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { CLOSE_DIALOGUE_AVATAR_FRAME } from "../../store/AvatarFrame/type";

const AvatarDialogue = (props) => {
  const { Dialogue, DialogueData } = useSelector((state) => state.avatarFrame);
  const [validity, setValidity] = useState("");
  const [validityType, setValidityType] = useState("");
  const [mongoId, setMongoId] = useState("");
  const [diamond, setDiamond] = useState("");
  const [familyCoin, setFamilyCoin] = useState("");
  const [name, setName] = useState("");
  const [errors, setError] = useState("");

  const [editImagePath, setEditImagePath] = useState("");
  const [editImageData, setEditImageData] = useState("");
  const [editPreviewImageData, setEditPreviewImageData] = useState("");
  const [editPreviewImagePath, setEditPreviewImagePath] = useState("");

  const [addPreviewImagePath, setAddPreviewImagePath] = useState("");
  const [addPreviewImageData, setAddPreviewImageData] = useState("");
  const [addImageData, setAddImageData] = useState("");
  const [addImagePath, setAddImagePath] = useState("");

  const [isSvga, setIsSvga] = useState(true);
  const [showInStore, setShowInStore] = useState(true);
  const [showInFamilyStore, setShowInFamilyStore] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (DialogueData) {
      setValidity(DialogueData.validity);
      setValidityType(DialogueData.validityType);
      setMongoId(DialogueData._id);
      setDiamond(DialogueData.diamond);
      setFamilyCoin(DialogueData.familyCoin || "");
      setName(DialogueData.name);
      setEditImagePath(DialogueData.image);
      setEditPreviewImagePath(DialogueData.imagePreview);
      setShowInStore(DialogueData.showInStore !== false);
      setShowInFamilyStore(DialogueData.showInFamilyStore === true);
      if (DialogueData?.image?.split(".")?.pop() === "svga") {
        setIsSvga(true);
      }
    }
  }, [DialogueData]);

  useEffect(
    () => () => {
      setValidity("");
      setValidityType("");
      setError("");
      setName("");
      setDiamond("");
      setFamilyCoin("");
      setIsSvga(true);
      setEditImageData(null);
      setEditImagePath(null);
      setEditPreviewImageData(null);
      setEditPreviewImagePath(null);
      setAddImageData(null);
      setAddImagePath(null);
      setAddPreviewImageData(null);
      setAddPreviewImagePath(null);
      setShowInStore(true);
      setShowInFamilyStore(true);
    },
    [Dialogue],
  );

  useEffect(() => {
    if (isSvga && editImagePath) {
      const svgaElement = document.getElementById("svga");
      if (svgaElement) {
        // Error handling
        try {
          const player = new SVGA.Player(`div[attr="${mongoId}"]`);
          const parser = new SVGA.Parser(`div[attr="${mongoId}"]`);
          parser.load(editImagePath, function (videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        } catch (error) {
          console.error("Error initializing SVGA Player:", error);
        }
      } else {
        console.error("SVGA element not found in the DOM");
      }
    }
  }, [editImagePath, isSvga, mongoId]);

  const closePopup = () => {
    dispatch({ type: CLOSE_DIALOGUE_AVATAR_FRAME });
  };

  useEffect(() => {
    if (addImagePath) {
      const svgaElement = document.getElementById("svgaAdd");
      if (svgaElement) {
        // Error handling
        try {
          var player = new SVGA.Player(`div[attr="addInputImage"]`);
          var parser = new SVGA.Parser(`div[attr="addInputImage}"]`);
          parser.load(addImagePath, function (videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          });
        } catch (error) {
          console.error("Error initializing SVGA Player:", error);
        }
      } else {
        console.error("SVGA element not found in the DOM");
      }
    }
  }, [addImagePath]);

  const handleSubmit = async () => {
    if (
      !name ||
      !diamond ||
      diamond < 0 ||
      !validity ||
      validity < 0 ||
      (showInFamilyStore && (!familyCoin || familyCoin < 0))
    ) {
      const errors = {};
      if (!validity) errors.validity = "Validity is required!";
      if (validity < 0) errors.validity = "invalid value of validity";
      if (!name) errors.name = "Name is Required";
      if (!diamond) errors.diamond = "Diamond is required";
      if (diamond < 0) errors.diamond = "Invalid Diamond ";
      if (showInFamilyStore && !familyCoin)
        errors.familyCoin = "Family coin is required";
      if (showInFamilyStore && familyCoin < 0)
        errors.familyCoin = "Invalid family coin";
      // if (images.length === 0) errors.images = "Please select an Image!";
      // TODO: Image validation
      return setError({ ...errors });
    } else {
      const formData = new FormData();
      formData.append("validity", validity);
      formData.append("validityType", validityType ? validityType : "day");
      formData.append("diamond", diamond);
      formData.append("familyCoin", showInFamilyStore ? familyCoin : "0");
      formData.append("showInStore", showInStore);
      formData.append("showInFamilyStore", showInFamilyStore);
      if (DialogueData) {
        if (editImageData) {
          formData.append("imageVideo", editImageData);
        }
        if (editPreviewImageData) {
          formData.append("previewImage", editPreviewImageData);
        }
      } else {
        if (addImageData) {
          formData.append("imageVideo", addImageData);
        }
        if (addPreviewImageData) {
          formData.append("previewImage", addPreviewImageData);
        }
      }
      formData.append("type", isSvga ? 2 : 1);
      formData.append("name", name);
      if (DialogueData) {
        try {
          const response = await props.updateAvatarFrame(mongoId, formData);
          if (!response.status) {
            return setError({ submit: response.message || "Unable to update avatar frame." });
          }
        } catch (error) {
          return setError({
            submit:
              error.response?.data?.message ||
              "Unable to update avatar frame. Please try again.",
          });
        }
      } else {
        props.crateAvatarFrame(formData);
      }
      closePopup();
    }
  };

  // for preview image
  const handleInputAddImage = (e) => {
    if (e.target.files[0]) {
      setAddImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setAddImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // for preview image
  const handleInputAddImagePreview = (e) => {
    if (e.target.files[0]) {
      setAddPreviewImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setAddPreviewImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleInputEditImage = (e) => {
    if (e.target.files[0]) {
      setEditImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setEditImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);

      if (e.target.files[0]?.name?.split(".")?.pop() === "svga") {
        setIsSvga(true);
      } else {
        setIsSvga(false);
      }
    }
  };

  const handleInputEditImagePreview = (e) => {
    if (e.target.files[0]) {
      setEditPreviewImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setEditPreviewImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <>
      <Dialog
        open={Dialogue}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        disableScrollLock
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">Avatar Frame</span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="text-gray mb-2">Name</label>

                  <input
                    type="text"
                    className="form-control"
                    required=""
                    placeholder="Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          name: "Name is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          name: "",
                        });
                      }
                    }}
                  />

                  {errors.name && (
                    <div className="ml-2 mt-1">
                      {errors.name && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.name}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Show in store</label>

                      <Switch
                        checked={showInStore}
                        onChange={(event) =>
                          setShowInStore(event.target.checked)
                        }
                        name="checkedA"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">
                        Show in family store
                      </label>

                      <Switch
                        checked={showInFamilyStore}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setShowInFamilyStore(checked);
                          if (!checked) {
                            setFamilyCoin("0");
                            setError({
                              ...errors,
                              familyCoin: "",
                            });
                          }
                        }}
                        name="checkedB"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Validity</label>
                      <input
                        type="number"
                        className="form-control"
                        required=""
                        placeholder="1"
                        min="0"
                        value={validity}
                        onChange={(e) => {
                          setValidity(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              validity: "Validity is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              validity: "",
                            });
                          }
                        }}
                      />
                      {errors.validity && (
                        <div className="ml-2 mt-1">
                          {errors.validity && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.validity}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Validity Type</label>
                      <select
                        className="form-select form-control"
                        aria-label="Default select example"
                        value={validityType}
                        onChange={(e) => {
                          setValidityType(e.target.value);
                        }}
                      >
                        <option value="day">Day</option>
                        <option value="Month">Month</option>
                        <option value="year">Year</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Diamond</label>
                  <input
                    type="number"
                    className="form-control"
                    required=""
                    min="0"
                    placeholder="20"
                    value={diamond}
                    onChange={(e) => {
                      setDiamond(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          diamond: "diamond is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          diamond: "",
                        });
                      }
                    }}
                  />
                  {errors.diamond && (
                    <div className="ml-2 mt-1">
                      {errors.diamond && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.diamond}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {showInFamilyStore && (
                  <div className="form-group mt-4">
                    <label className="mb-2 text-gray">Family Coin</label>
                    <input
                      type="number"
                      className="form-control"
                      required=""
                      min="0"
                      placeholder="10"
                      value={familyCoin}
                      onChange={(e) => {
                        setFamilyCoin(e.target.value);
                        if (!e.target.value) {
                          return setError({
                            ...errors,
                            familyCoin: "family coin is Required!",
                          });
                        } else {
                          return setError({
                            ...errors,
                            familyCoin: "",
                          });
                        }
                      }}
                    />
                    {errors.familyCoin && (
                      <div className="ml-2 mt-1">
                        {errors.familyCoin && (
                          <div className="pl-1 text__left">
                            <span className="text-red">
                              {errors.familyCoin}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {DialogueData ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">Select SVGA</label>
                      <input
                        type="file"
                        accept=".svga"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputEditImage}
                      />
                      {editImagePath && (
                        <>
                          <div
                            id="svga"
                            attr={mongoId}
                            style={{
                              boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                              marginTop: 10,
                              float: "left",
                              objectFit: "contain",
                              marginRight: 15,
                              height: "100px",
                              width: "100px",
                            }}
                          ></div>
                        </>
                      )}
                    </div>

                    {/* preview image */}
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">
                        Select Preview Image
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputEditImagePreview}
                      />
                      {editPreviewImagePath && (
                        <>
                          <img
                            src={editPreviewImagePath}
                            className="mt-3 rounded float-left mb-2"
                            height="100px"
                            width="100px"
                          />
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      className="form-group mt-4"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label className="mb-2 text-gray">Select SVGA</label>
                      <input
                        type="file"
                        accept=".svga"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputAddImage}
                      />
                      {addImagePath && (
                        <>
                          <div
                            id="svgaAdd"
                            attr="addInputImage"
                            style={{
                              boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                              marginTop: 10,
                              float: "left",
                              objectFit: "contain",
                              marginRight: 15,
                              height: "100px",
                              width: "100px",
                            }}
                          ></div>
                        </>
                      )}
                    </div>

                    {/* preview image */}
                    <div className="form-group mt-4">
                      <label className="mb-2 text-gray">
                        Select Preview Image
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control form-control-sm"
                        required=""
                        onChange={handleInputAddImagePreview}
                      />
                      {addPreviewImagePath && (
                        <>
                          <img
                            src={addPreviewImagePath}
                            className="mt-3 rounded float-left mb-2"
                            height="100px"
                            width="100px"
                          />
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className={editImagePath ? "mt-5 pt-5" : "mt-5"}>
                  {errors.submit && (
                    <div className="text-red mb-2">{errors.submit}</div>
                  )}
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { updateAvatarFrame, crateAvatarFrame })(
  AvatarDialogue,
);
